/* eslint-disable max-len */
import React from 'react';

const ToggleSwitch = ({ checked, onChange, disabled = false, id, dataTestId }) => {
    const handleToggle = (e) => {
        if (!disabled && onChange) {
            onChange(e.target.checked);
        }
    };

    return (
        <div className="relative inline-block">
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={handleToggle}
                disabled={disabled}
                data-testid={dataTestId}
                className="sr-only peer"
            />
            <label
                htmlFor={id}
                className={`
                    relative inline-block 
                    w-[44px] h-[24px] 
                    rounded-full 
                    transition-colors 
                    duration-200 
                    cursor-pointer
                    ${checked ? 'bg-[#00A3A3]' : 'bg-[#C5C9DA]'}
                    ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
                `}
            >
                <span
                    className={`
                        absolute top-[2px] left-[2px] 
                        w-[20px] h-[20px] 
                        bg-white 
                        rounded-full 
                        transition-transform 
                        duration-200
                        ${checked ? 'translate-x-[20px]' : 'translate-x-0'}
                    `}
                />
            </label>
        </div>
    );
};

export default ToggleSwitch;

